import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ElearnioLanguageSpanModule } from '@shared/elearnio-language-icon/elearnio-language-span.module';

import { LanguageSelectorComponent } from './language-selector.component';

export const declarations = [LanguageSelectorComponent];
export const imports = [
  CommonModule,
  MatMenuModule,
  MatButtonModule,
  MatIconModule,
  TranslateModule,
  ElearnioLanguageSpanModule,
];

@NgModule({
  declarations: [LanguageSelectorComponent],
  imports,
  exports: [LanguageSelectorComponent],
})
export class LanguageSelectorModule {}
